import { Button, TextField } from "@material-ui/core";
import React, { useState } from "react";
import { Alert } from "react-bootstrap";
import { MESApiService } from "../../services";
import { AuthContext } from "../AuthProvider";

export const LoginWithEmailAndPassword = () => {
	const [username, setUserName] = useState("");
	const [password, setPassword] = useState("");
	const [showError, setShowError] = React.useState(false);
	const [error, setError] = React.useState<any>(undefined);

	const { saveUserData } = React.useContext(AuthContext);

	const login = async (e: any) => {
		e.preventDefault();
		const apiService = new MESApiService();
		const response = await apiService.authenticate(username, password);
		if (apiService.hasErrors) {
			setShowError(true);
			setError(apiService.error);
		} else {
			saveUserData(response);
		}
	};

	return (
		<>
			<form onSubmit={login}>
				<div className="form-group row">
					<TextField
						variant="outlined"
						margin="dense"
						id="txtUserName"
						label="User"
						name="userName"
						onChange={(e) => setUserName(e.target.value)}
						type="text"
						autoComplete="off"
						className="form-control"
					></TextField>
				</div>
				<div className="form-group row">
					<TextField
						variant="outlined"
						margin="dense"
						id="txtPassword"
						label="Password"
						name="password"
						onChange={(e) => setPassword(e.target.value)}
						type="password"
						className="form-control"
					></TextField>
				</div>
				<div className="row">
					<Button
						fullWidth
						variant="contained"
						style={{
							backgroundColor:
								password.length === 0 || username.length === 0
									? "#CCCCCC"
									: "#479DC4",
							color:
								password.length === 0 || username.length === 0
									? "black"
									: "white",
						}}
						type="submit"
						disabled={password.length === 0 || username.length === 0}
					>
						Login
					</Button>
				</div>
				<Alert
					style={{ marginTop: 20 }}
					show={showError}
					variant="danger"
					dismissible={true}
					onClose={() => {
						setShowError(false);
						setError(undefined);
					}}
				>
					<strong>Bad credentials</strong>
					<p>
						{" "}
						{error === undefined
							? "There was an error"
							: error.internalError.message === undefined
								? error.internalError
								: error.internalError.message}
					</p>
				</Alert>
			</form>
		</>
	);
};
